import { takeLatest, call, put } from 'redux-saga/effects'
import { ErrorToast, SuccessToast } from 'components/ui/toast/toastsTemplates'
import I18n from 'i18n'

import * as fromActions from '../../actions/participants.action'
import downloadUsers, {
  DownloadUsersOpts,
} from '../../../api/administration/participants/Download'

async function downloadParticipants(opts: DownloadUsersOpts) {
  return downloadUsers(opts)
}

function* participantsDownloadEffectSaga(action) {
  try {
    const { disabled = false, areaIds = undefined } = action.payload ?? {}
    const { data } = yield call(downloadParticipants, { disabled, areaIds })
    if (typeof data === 'string') {
      SuccessToast(I18n.t('administration.toastMessages.downSuccess'))
    } else {
      SuccessToast(I18n.t('administration.toastMessages.downloadSent'))
    }
    yield put(fromActions.Actions.participantDownloadSuccess(data))
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.downloadError'))
    console.error(error)
  }
}

export function* participantsDownloadWatcherSaga() {
  yield takeLatest(
    fromActions.PARTICIPANTS_DOWNLOAD,
    participantsDownloadEffectSaga
  )
}
